import { InjectionToken } from '@angular/core';

export const AUTH_URL_FILTER = new InjectionToken<string[]>('AUTH_URL_FILTER');
